import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
//Importo o componente de conteudo
import Globals from './Components/Miscelania/Globals';
import RequestApi from './Components/Miscelania/RequestApi';

//Importo as views

// Users
import Login from './Components/Users/Login';
import ExamsIndex from './Components/Exams/ExamsIndex';
import ExamEdit from './Components/Exams/ExamEdit';
import ExamQuestion from './Components/Exams/ExamQuestion';
import ExamConfirmation from './Components/Exams/ExamConfirmation';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect_url: false,
      prova: [],
      questao_selecionada: null,
      questoes_feitas: 0,
    };
    this.setProva = this.setProva.bind(this);
    this.verificaProva = this.verificaProva.bind(this);
    this.questaoSelecionada = this.questaoSelecionada.bind(this);
    this.marcarOpcao = this.marcarOpcao.bind(this);
    this.calcularQuestoesFeitas = this.calcularQuestoesFeitas.bind(this);
  }

  setProva(dados) {
    var self = this;
    this.setState({prova: dados});
    var verificacao = 0;
    Object.keys(dados).map(function(k) {
      if(verificacao === 0) {
        self.setState({prova_qtd_questoes: dados[k].team_training_matter_staff_exam.qtd_questoes});
        verificacao = 1;
      }
    });
    localStorage.setItem("prova", JSON.stringify(dados));
    this.calcularQuestoesFeitas();
  }

  questaoSelecionada(question_id) {
    this.setState({questao_selecionada: question_id});
    return true;
  }

  marcarOpcao(opcao, question_id) {
    var opcao_str = opcao.toUpperCase();
    var prova = this.state.prova;
    prova[question_id].selected_str = opcao_str;
    prova[question_id].selected = opcao;
    this.setState({prova: prova});
    localStorage.setItem("prova", JSON.stringify(prova));
    this.calcularQuestoesFeitas();
  }

  calcularQuestoesFeitas() {
    var self = this;
    var questoes_feitas = 0;
    Object.keys(this.state.prova).map(function(k) {
      if(self.state.prova[k].selected !== null && typeof self.state.prova[k].selected !== 'undefined') {
        questoes_feitas = questoes_feitas + 1;
      }
    });
    this.setState({questoes_feitas: questoes_feitas});
  }

  verificaProva(dados) {
    var params = JSON.parse(localStorage.getItem("prova"));
    // Verifico se há alguma prova setada no storage
    //if(params === null) {
    if(params === null || typeof params === 'undefined') {
      return false;
    } else {
      this.setProva(params);
      return true;
    }
  }

  render() {
    var self = this;
    return (
      <div>
          <RequestApi ref={'request_api'} />         
          <div>
            <BrowserRouter>
              <Switch>
                {/* Usuários */}
                <Route path="/prova/link/:token" component={Login} />
                {/* Usuários */}
                <Route path="/usuario/liberar/prova/:id" component={ExamConfirmation} />
                {/* Provas */}
                <Route path="/usuario/prova/questao" render={(props)=>(
                  <ExamQuestion questaoSelecionada={self.state.questao_selecionada} dadosProva={self.state.prova} questoesFeitas={self.state.questoes_feitas} questaoMarcarOpcao={self.marcarOpcao} qtd_questoes={self.state.prova_qtd_questoes} selecionarQuestao={self.questaoSelecionada} dadosProva={self.state.prova}/>
                  )} />
                <Route path="/usuario/provas" render={(props)=>(
                  <ExamsIndex setProva={self.setProva}/>
                  )} />
                <Route path="/usuario/prova" render={(props)=>(
                  <ExamEdit dadosProva={self.state.prova} questoesFeitas={self.state.questoes_feitas} verificaProva={self.verificaProva} selecionarQuestao={self.questaoSelecionada}/>
                )} />
                <Route path="/" component={Login} />
              </Switch>
            </BrowserRouter>
          </div>
      </div>
    );
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js